import { hex2Rgb, getColorWithAlpha } from "./tools";
interface ICustomSet {
    [key: string]: any
}

interface ICssVars {
    [key: string]: number | string
}

export function generateTagStyleVars(setting?: ICustomSet): ICssVars {
    if(!setting) return {};
    return {
        '--tab-default-color': setting?.tabDefaultColor,
        '--tab-selected-color': setting?.tabSelectedColor,
        '--tab-underline-color': setting?.underlineColor1,
        '--tab-underline-color2': setting?.underlineStyle === 'gradient' ? setting?.underlineColor2 : setting?.underlineColor1,
        '--tab-underline-radius': setting?.underlineRadius + 'px',
        '--tab-bg-color': setting?.tabBgColor || '',
        '--adm-color-primary': setting?.primaryColor,
        '--adm-color-secondary': setting?.secondaryColor,

    }
}

export function generateCertificateStyleVars(setting?: ICustomSet, isNeedRbgPackage = false): ICssVars {
    if(!setting) return {};
    return {
        '--certify-bg-color': setting?.bgColor,
        '--certify-primary-color': setting?.primaryColor,
        '--certify-secondary-color': setting?.secondaryColor,
        '--certify-bg-color-rgb': hex2Rgb(setting?.bgColor ?? ''),
        '--certify-primary-color-rgb': hex2Rgb(setting?.primaryColor ?? ''),
        '--certify-secondary-color-rgb': hex2Rgb(setting?.secondaryColor ?? ''),
        '--adm-color-primary': setting?.primaryColor,
        '--adm-color-secondary': setting?.secondaryColor,
        '--dpm-color-primary': setting?.primaryColor,
        '--background-color': setting?.primaryColor,
        '--background-color-secondary': setting?.primaryColor,
        // '--background-color-secondary': setting?.secondaryColor || setting?.primaryColor,
        // '--border-color': setting?.primaryColor,
        // '--page-bg-color': '#242321',
        // '--page-bg-color-secondary': '#32312e',
        // '--content-bg-color': 'rgba(255, 255, 255, .1)',
        // '--info-bg-color': 'rgba(255, 255, 255, .1)',
        // '--content-item-bg-color': '#32312E',
        // '--primary-text-color': '#fff'
    }
}

export function generateButtonStyle(setting?: ICustomSet): ICssVars {
    if(!setting) return {};
    return {

      '--btn-border-style': setting.borderStyle,
      '--btn-border-radius': setting.borderRadius + 'px',
      '--border-radius': setting.borderRadius + 'px',
      '--adm-button-border-radius': setting.borderRadius + 'px',
      '--color': setting.color ?? '',
    }
}

export function generateH5Style(setting?: ICustomSet) {
    if(!setting) return {};
    return {}
}

export function generateAllStyles(settings: ICustomSet): ICssVars {
    const {h5Setting, tagStyle, buttonStyle, certificatePage} = settings;
    const certifyStyleVars = generateCertificateStyleVars(certificatePage);
    const h5StyleVars = generateH5Style(h5Setting);
    const tagStylesVars = generateTagStyleVars({ ...tagStyle, ...certificatePage});
    const buttonStyleVars = generateButtonStyle(buttonStyle);
    
    return {
        ...certifyStyleVars,
        ...h5StyleVars,
        ...tagStylesVars,
        ...buttonStyleVars,
    }

}


// ##只用到生消健康  主题色重构主题可以放存储
// just font
export function livingPrimaryColor({ setting = {
  primaryColor: '#F34242',
  secondaryColor: '#D5865B'
} } : { setting?: ICustomSet }): ICssVars {
  if(!setting) return {};
  return {
    ...(setting?.certificatePage ||  setting || {}),
    color: setting?.primaryColor,
    '--certify-primary-color': setting?.primaryColor,
    '--adm-color-primary': setting?.primaryColor,
  }
}

// 只是底色
export function livingPrimaryBgColor({ setting = {
  primaryColor: '#F34242',
  secondaryColor: '#D5865B'
}, isNeedRbgPackage = true, alpha = 1, sameColor = '#ffffff' }: {
  setting: ICustomSet,
  isNeedRbgPackage?: boolean,
  alpha?: number,
  sameColor?: string
} ): ICssVars {
  if(!setting) return {};
  return {
    ...setting?.certificatePage || setting ,
    // backgroundColor: hex2Rgb(setting?.primaryColor, isNeedRbgPackage, alpha),
    '--certify-bg-color': hex2Rgb(setting?.primaryColor, isNeedRbgPackage, alpha),
    '--certify-bg-color-rgb': hex2Rgb(setting?.primaryColor ?? '', isNeedRbgPackage, alpha),
    '--background-color': hex2Rgb(setting?.primaryColor, isNeedRbgPackage, alpha),

    '--background-color-secondary': setting?.secondaryColor || setting?.primaryColor,
    '--border-color': setting?.primaryColor,
    '--page-bg-color': '#242321',
    '--page-bg-color-secondary': '#32312e',
    '--content-bg-color': 'rgba(255, 255, 255, .1)',
    '--info-bg-color': 'rgba(255, 255, 255, .1)',
    '--content-item-bg-color': '#32312E',
    '--primary-text-color': '#fff'
  }
}

// 按钮
export function livingPrimaryButtonColor({ setting = {
  certificatePage: {
    primaryColor: '#F34242',
    secondaryColor: '#D5865B'
  },
  buttonStyle: {}
}, isNeedRbgPackage = true, alpha = 1, sameColor = '#ffffff' }: {
  setting: ICustomSet,
  isNeedRbgPackage?: boolean,
  alpha?: number,
  sameColor?: string,
} ): ICssVars {
  if(!setting) return {};
  const certificatePage: any = setting?.certificatePage || {
    primaryColor: '#F34242',
    secondaryColor: '#D5865B'
  }
  const buttonStyle =  setting?.buttonStyle || {}
  return {
    ...buttonStyle,
    color: sameColor || hex2Rgb(certificatePage?.primaryColor ?? '', isNeedRbgPackage, 1),
    backgroundColor: hex2Rgb(certificatePage?.primaryColor ?? '', isNeedRbgPackage, alpha),
    '--background-color': hex2Rgb(certificatePage?.primaryColor ?? '', isNeedRbgPackage, alpha),
    '--certify-bg-color': hex2Rgb(certificatePage?.primaryColor ?? '', isNeedRbgPackage, alpha),
    '--certify-primary-color': certificatePage?.primaryColor,
    '--certify-secondary-color': certificatePage?.secondaryColor,
    '--certify-bg-color-rgb': hex2Rgb(certificatePage?.primaryColor ?? '', isNeedRbgPackage, alpha),
    '--certify-primary-color-rgb': hex2Rgb(certificatePage?.primaryColor ?? '', isNeedRbgPackage, alpha),
    '--adm-color-primary': certificatePage?.primaryColor,
    '--btn-border-style': buttonStyle.borderStyle,
    '--btn-border-radius': buttonStyle.borderRadius + 'px',
    '--border-radius': buttonStyle.borderRadius + 'px',
    '--adm-button-border-radius': buttonStyle.borderRadius + 'px',
  }
}

// export function livingRightIcon(setting?: ICustomSet): ICssVars {
//   if(!setting) return {};
//   setting.primaryColor = '#ffff00'
//   setting.secondaryColor = '#800080'
//   return {
//     ...setting?.certificatePage ||  setting ,
//     color: setting?.primaryColor,
//     '--certify-primary-color': setting?.primaryColor,
//     '--adm-color-primary': setting?.primaryColor,
//   }
// }

// 初始化酒店使用，自定义背景和文字各种
export function getCustomThemeStyles(_setting?: ICustomSet, isNeedRbgPackage = false): ICssVars {
  // if(!_setting?.h5Setting) return {};
  const setting: ICustomSet = {
    ..._setting,
    h5Setting: {
      "primaryBackgroundColor": "#f5f6f8", // 主背景色
      "secondaryBackgroundColor": "#ffffff", // 辅背景色
      "secondaryBackgroundColor1": _setting?.h5Setting?.primaryBackgroundColor || "#f5f6f8", // 辅背景色1
      "primaryColorType": "pure", // 主题色模式 左到右线性渐变|horizontalGradient、上到下线性渐变|verticalGradient、纯色|pure
      "primaryColor1": _setting?.certificatePage?.primaryColor || "#F34242", // 主题色1
      // "primaryColor2":  _setting?.certificatePage?.primaryColor1 || _setting?.certificatePage?.primaryColor || "#F34242", // 主题色2
      "secondaryColor": _setting?.certificatePage?.secondaryColor || "#32312E", // 辅助色2
      "textColor": '#222222',
      ..._setting?.h5Setting
    }
  }
  return {
      '--text-color': setting?.h5Setting?.textColor,
      '--certify-bg-color': setting?.h5Setting?.primaryBackgroundColor,
      '--certify-primary-color': setting?.h5Setting?.primaryColor1,
      '--certify-secondary-color': setting?.h5Setting?.secondaryColor,

      '--certify-bg-color-rgb': hex2Rgb(setting?.h5Setting?.primaryBackgroundColor ?? '', true, 1),
      '--certify-primary-color-rgb': hex2Rgb(setting?.h5Setting?.primaryColor1 ?? '', true, 1),
      '--certify-secondary-color-rgb': hex2Rgb(setting?.h5Setting?.secondaryColor ?? '', true, 1),

      '--adm-color-primary': setting?.h5Setting?.primaryColor1,
      '--adm-color-secondary': setting?.h5Setting?.secondaryColor,

      '--background-linear-gradient': setting?.h5Setting?.primaryColorType === 'verticalGradient' ? 'to right' : '45deg',
      '--background-color': setting?.h5Setting?.primaryColor1, // 背景色-1，渐变色-1
      '--background-color-secondary': setting?.h5Setting?.primaryColor2 || setting?.h5Setting?.primaryColor1 || _setting?.certificatePage?.primaryColor , // 背景色-2，渐变色-2
      '--background-color-third': hex2Rgb(setting?.h5Setting?.primaryColor1?? '', true, 0.3), // 背景色-3，主题色1的30%
      '--background-color-opacity': hex2Rgb(setting?.h5Setting?.primaryColor1?? '', true, 0.1), // 背景色
      '--background-color-affirm': hex2Rgb(setting?.h5Setting?.primaryColor1?? '', true, 0.6), // 背景色

      '--page-bg-color': setting?.h5Setting?.primaryBackgroundColor, // 主背景色-1，渐变色-1
      '--page-bg-color-secondary': setting?.h5Setting?.secondaryBackgroundColor, // 主背景色-2，渐变色-2
      '--content-bg-color': setting?.h5Setting?.secondaryBackgroundColor, // 辅助背景色-2，渐变色-2
      '--info-bg-color': setting?.h5Setting?.secondaryBackgroundColor1 || hex2Rgb(setting?.h5Setting?.textColor ?? '', true, 0.2), // 背景色-2，某些标签
      // '--info-bg-color': setting?.h5Setting?.secondaryBackgroundColor1 || hex2Rgb(setting?.h5Setting?.textColor ?? '', true, 0.2), // 背景色-2，某些标签
      '--disabled-bg-color': getColorWithAlpha(setting?.h5Setting?.primaryBackgroundColor ?? '', 0.1), // 背景色-2，某些标签

      '--primary-text-color': setting?.h5Setting?.textColor, // 主题字体色
      '--secondary-text-color': hex2Rgb(setting?.h5Setting?.textColor, true, 0.8),
      '--third-text-color': hex2Rgb(setting?.h5Setting?.textColor, true, 0.6),
      '--four-text-color': hex2Rgb(setting?.h5Setting?.textColor, true, 0.4),

      '--tag-bg-color': hex2Rgb(setting?.h5Setting?.secondaryColor, true, 0.2), // 辅助色30%
      '--tag-bg-color-hp': getColorWithAlpha(setting?.h5Setting?.secondaryColor, 0.2), // 辅助色30%
      '--tag-bg-color-secondary': hex2Rgb(setting?.h5Setting?.secondaryColor, true, 0.2),// 辅助色30%
      '--tag-primary-color': setting?.h5Setting?.secondaryColor, // 标签主题色-字体-1
      '--tag-secondary-color': setting?.h5Setting?.secondaryColor, // 标签辅助色-字体-2

      '--button-bg-color': getColorWithAlpha(setting?.buttonStyle?.backgroundColor1 || setting?.h5Setting?.primaryColor1, 1), // 按钮背景色-1 z
      '--button-bg-color-secondary': getColorWithAlpha(setting?.buttonStyle?.backgroundColor2 || setting?.buttonStyle?.backgroundColor1 || setting?.h5Setting?.primaryColor1, 1),// 按钮背景色-2
      '--button-bg-color-dashed': hex2Rgb((setting?.buttonStyle?.backgroundColor2 || setting?.buttonStyle?.backgroundColor1 || setting?.h5Setting?.primaryColor1) ?? '', true, 0.1),// 按钮背景色-2
      '--button-bg-linear-gradient': setting?.buttonStyle?.backgroundColorType === 'verticalGradient' ? 'to right' : '45deg',

      '--button-primary-color': getColorWithAlpha(setting?.buttonStyle?.textColor ?? '', 1), // 按钮主题色-字体-1
      '--button-secondary-color': getColorWithAlpha(setting?.buttonStyle?.textColor  ?? '', 0.8), // 按钮辅助色-字体-2

      '--button-width': setting?.buttonStyle?.borderStyle === 'none' ? 0  : '1px', // 按钮宽度
      '--button-border-style': 'none', // 按钮 - border样式
      '--btn-border-style': setting?.buttonStyle?.borderStyle,  // 按钮 - border样式
      '--btn-border-radius': (setting?.buttonStyle?.borderRadius || 0) + 'px',  // 按钮 - border样式

      '--adm-button-border-radius':(setting?.buttonStyle?.borderRadius || 0) + 'px',

      '--tab-border-color': hex2Rgb(setting?.h5Setting?.textColor, true, 0.08), // tab的线色
      '--input-placeholder-color': hex2Rgb(setting?.h5Setting?.textColor, true, 0.2),
      '--shadow-color': hex2Rgb(setting?.h5Setting?.textColor, true, 0.08), // 阴影
      // '--search-input-bg-color': getColorWithAlpha('#32312e' ?? '', 0.9)

  }
}
